import React, { useEffect, memo, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { userPropTypes } from 'helpers/propTypes';

import compraSeguraImage from 'views/Checkout/assets/compra-segura.png';


import Input from 'components/commons/Input';
import Button from 'components/commons/Button';
import Select from 'components/commons/Select';
import ShippingQuote from 'components/commons/ShippingQuote';

import './DeliveryForm.scss';
import { getProvinces } from 'services/user.services';

const validate = (values) => {
  const errors = {};
  if (!values.first_name) {
    errors.first_name = 'Nombre inválido';
  }
  if (!values.last_name) {
    errors.last_name = 'Apellido inválido';
  }
  if (!values.email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Dirección de email inválida';
  }
  if (!values.id_card || !/^[0-9]*$/i.test(values.id_card)) {
    errors.id_card = 'Numero inválido';
  }
  if (!values.phone || !/^(54)?[1-9]\d{9}$/i.test(values.phone)) {
    errors.phone = 'Número inválido (Ej: 541123456789)';
  }
  if (!values.address) {
    errors.address = 'Dirección inválida';
  }
  if (!values.postal_code) {
    errors.postal_code = 'Código postal inválido';
  }
  if (!values.locality) {
    errors.locality = 'Localidad inválida';
  }
  if (!values.province) {
    errors.province = 'Provincia inválida';
  }
  return errors;
};

const DeliveryForm = (props) => {
  const {
    handleSubmit, initialize, onSubmit, submitting, user,
    couponText, setCouponText, onSubmitCoupon, coupon, emailComplete,
    setEmailComplete, validationEmailCoupon, setEmailCoupon,
    cartQuote, cartQuoteLoading, getCartQuoteAction, zipCode,
    showShippingQuote = false,
  } = props;
  const [provinces, setProvinces] = useState([]);
  const options = provinces.map((province) => ({ label: province.name, value: province.name }));

  const callProvinces = async () => {
    try {
      const responce = await getProvinces();
      setProvinces(responce.items);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  useEffect(() => {
    callProvinces();
    let initialValues = {};
    if (user) {
      initialValues = { ...initialValues, ...user };
      setEmailComplete(true);
      setEmailCoupon(user.email);
    }
    if (zipCode) {
      initialValues = { ...initialValues, postal_code: zipCode };
    }
    initialize(initialValues);
    // eslint-disable-next-line
  }, [user, setEmailComplete, setEmailCoupon, zipCode]);

  const onKeyPress = (event) => {
    if (event.key === 'Enter') {
      onSubmitCoupon();
    }
  };

  return (
    <div className="container checkout-step checkout-step--delivery" data-testid="delivery-form">
      <div className="row">
        <div className="form-container">
          <div className="checkout-section-header">
            <div>
              <h3 className="checkout-section-title">Datos de envío</h3>
              <div className="checkout-section-subtitle">
                Completá tus datos para habilitar el pago abajo.
              </div>
            </div>
            <div className="secure-badge" aria-label="Compra segura">
              <img className="secure-badge__image" src={compraSeguraImage} alt="Compra segura" />
              <div className="secure-badge__text">
                <div className="secure-badge__title">COMPRA SEGURA</div>
                <div className="secure-badge__subtitle">100% PROTEGIDO</div>
              </div>
            </div>
          </div>
          <form className="redux-form" onSubmit={handleSubmit(onSubmit)}>
            {showShippingQuote && (
              <ShippingQuote
                onSubmit={getCartQuoteAction}
                quote={cartQuote}
                zipCode={zipCode}
                loading={cartQuoteLoading}
                showQuote={false}
              />
            )}
            {((showShippingQuote && !cartQuoteLoading && cartQuote) || !showShippingQuote) && (
              <>
                <Field
                  component={Input}
                  label="Nombre"
                  name="first_name"
                />
                <Field
                  component={Input}
                  label="Apellido"
                  name="last_name"
                />
                <Field
                  component={Input}
                  disabled={!!user}
                  label="Email"
                  onChange={(event) => validationEmailCoupon(event.target.value)}
                  name="email"
                />
                <Field
                  component={Input}
                  label={process.env.REACT_APP_CLIENT_ID === "5" ? "CUIT" : "DNI"}
                  name="id_card"
                  type="number"
                />
                <Field
                  component={Input}
                  label="Celular / WhatsApp"
                  name="phone"
                  type="number"
                />
                <div className="row">
                  <Field
                    component={Input}
                    formGroupClassName="col-sm-6"
                    label="Dirección"
                    name="address"
                  />
                  <Field
                    component={Input}
                    formGroupClassName="col-sm-6"
                    label="Altura"
                    name="number"
                    type="number"
                  />
                </div>
                <div className="row">
                  <Field
                    component={Input}
                    formGroupClassName="col-sm-6"
                    label="Piso"
                    name="floor"
                  />
                  <Field
                    component={Input}
                    formGroupClassName="col-sm-6"
                    label="Departamento"
                    name="departament"
                  />
                </div>
                <Field
                  component={Input}
                  label="Codigo Postal"
                  name="postal_code"
                />
                <Field
                  component={Input}
                  label="Localidad"
                  name="locality"
                />
                <div>
                  <Field
                    component={Input}
                    label="Aplicar Cupon"
                    name="coupon"
                    disabled={!!coupon || !emailComplete}
                    value={couponText}
                    onChange={(event) => setCouponText(event.target.value)}
                    onKeyPress={onKeyPress}
                  />
                  <Button
                    buttonClass={!coupon ? 'btn-search-set' : 'btn-search-reset'}
                    disabled={!emailComplete}
                    text={
                      !coupon ? ' Aplicar Cupon ' : <i className="fa fa-trash-o" aria-hidden="true" />
                    }
                    type="button"
                    onClick={onSubmitCoupon}
                  />
                </div>
                <Field label="Provincia" name="province" component={Select} options={options} />
                <Field
                  component={Input}
                  label="Desea recibir novedades"
                  name="suscribe"
                  type="checkbox"
                />
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

DeliveryForm.defaultProps = {
  user: null,
  coupon: null,
  couponText: '',
  emailComplete: false,
  zipCode: '',
};

DeliveryForm.propTypes = {
  coupon: PropTypes.shape({
    id: PropTypes.number.isRequired,
    percentage: PropTypes.number.isRequired,
  }),
  handleSubmit: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  user: userPropTypes,
  couponText: PropTypes.string,
  setCouponText: PropTypes.func.isRequired,
  emailComplete: PropTypes.bool,
  onSubmitCoupon: PropTypes.func.isRequired,
  setEmailComplete: PropTypes.func.isRequired,
  setEmailCoupon: PropTypes.func.isRequired,
  validationEmailCoupon: PropTypes.func.isRequired,
  cartQuote: PropTypes.object,
  cartQuoteLoading: PropTypes.bool.isRequired,
  zipCode: PropTypes.string,
  showShippingQuote: PropTypes.bool,
};

export default reduxForm({
  form: 'delivery',
  validate,
})(memo(DeliveryForm));
